
import { Player } from "@lottiefiles/react-lottie-player";
import loader1 from "../assets/animation/loader1.json";

const TydiiLoader = () => {
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/30 backdrop-blur-sm">
      <Player
        autoplay
        loop
        src={loader1}
        style={{ height: "300px", width: "300px" }}
      />
    </div>
  );
};

export default TydiiLoader;
